import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DescriptorValidationServices from "./DescriptorValidation.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDescriptorValidation =
  (item, onlyGeneralData, carreer) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_DESCRIPTOR_VALIDATION,
        payload: true,
      });
      if (item) {
        const resp = await DescriptorValidationServices.getDescriptorValidation(
          {
            id: item.id,
          },
          onlyGeneralData,
          carreer
        );
        if (carreer) {
          dispatch({
            type: actions.DESCRIPTOR_VALIDATION,
            payload: {
              descriptorExist: true,
              descriptorComplete: true,
              menssege: "",
              divisions: [],
              descriptor: resp.data.descriptor_id[0].id,
            },
          });
        } else {
          dispatch({
            type: actions.DESCRIPTOR_VALIDATION,
            payload: {
              descriptorExist: true,
              descriptorComplete: true,
              menssege: "",
              divisions: resp.data.division ? resp.data.division : [],
              descriptor: null,
            },
          });
        }
      } else {
        dispatch({
          type: actions.DESCRIPTOR_VALIDATION,
          payload: {
            descriptorExist: true,
            descriptorComplete: true,
            menssege: "",
            divisions: [],
          },
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              dispatch({
                type: actions.DESCRIPTOR_VALIDATION,
                payload: {
                  descriptorExist:
                    ex.response.data.mensaje ===
                    "No existe un descriptor para la posicion proporcionada"
                      ? false
                      : true,
                  descriptorComplete:
                    ex.response.data.mensaje ===
                    "No existe un descriptor para la posicion proporcionada"
                      ? true
                      : false,
                  menssege: ex.response.data.mensaje,
                  divisions: [],
                },
              });
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      console.error(message);
    } finally {
      dispatch({
        type: actions.LOADING_DESCRIPTOR_VALIDATION,
        payload: false,
      });
    }
  };
